import { DropdownContainer, IconButton } from '@lib/components'
import type { ID } from '@octopus-do/octopus-project-core'
import { EllipsisVertical } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { RootMenu } from './components'
import css from './styles.module.css'

interface Props {
  nodeId: ID
}

export const SeoSidebarMenu: React.FC<Props> = ({ nodeId }) => (
  <DropdownContainer
    position="bottom-end"
    offset={{ y: 8, x: 32 }}
    renderButton={(onSetRef, onClick, isOpen) => (
      <IconButton
        eventHandlers={{ onSetRef }}
        icon={<EllipsisVertical className="svg-icon" />}
        active={isOpen}
        classNames={css.seo_sidebar_menu_button}
        onClick={onClick}
      />
    )}
  >
    {(closeDropdown) => (
      <RootMenu nodeId={nodeId} onCloseDropdown={closeDropdown} />
    )}
  </DropdownContainer>
)
